import React,{ useState,useEffect, useRef} from "react";
import "./Define.css";
import { useSelector, useDispatch } from "react-redux";
import { Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { setState } from "./defineSlice";
import {
   biWeeklyDepCols,
   noDepCols,
   summaryView,
   weeklyDepCols,
} from "./DefineQuotaBreakdownCols";
import './Define.css'

function DefineQuotaBreakdown() {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const {
      selectedRows,
      gridDataFiltered,
      selectedDepletion,
      selectedView
   } = define;
   const prevRowSelectionModel = useRef([]);
   const [paginationModel, setPaginationModel] = useState({
      pageSize: 20,
      page: 0,
   });

   function selectColumn() {
      if(selectedView === 2) {
         return summaryView;
      }
      if(selectedDepletion === null || selectedDepletion === undefined || selectedDepletion.value === undefined) {
         return noDepCols;
      }else{
      if (selectedDepletion.key === "biweekly") {
         return biWeeklyDepCols;
      }
      if (selectedDepletion.value === "No depletion") {
         return noDepCols;
      }
      return weeklyDepCols;
      }
   }
 
   useEffect(()=>{
      if(selectedRows.length === 0){
         prevRowSelectionModel.current = [];
      }
   },[selectedRows])
 
   const handleRowSelectionChange = (newRowSelectionModel) => {
      let rowSelected = [];
      for(let i = 0; i< prevRowSelectionModel?.current?.length; i++){
        let idx = gridDataFiltered.findIndex(x => x.id === prevRowSelectionModel.current[i]);
        if(idx === -1){
          rowSelected.push(prevRowSelectionModel.current[i]);
        }
      }
      const mergedSelectionModel = Array.from(new Set([...rowSelected, ...newRowSelectionModel]));
      prevRowSelectionModel.current = mergedSelectionModel;
      dispatch(setState("selectedRows", mergedSelectionModel));
    }
 
   return (
      <Grid container direction="column" spacing={2}>
         <Grid item sx={{ width: "100%" }}>
            <div //className = "hide-scrollbar"
            >
            <DataGrid sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal"
          },
          "& .MuiDataGrid-columnHeader": {
            // Forced to use important since overriding inline styles
            height: "unset !important"
          },
          "& .MuiDataGrid-columnHeaders": {
            // Forced to use important since overriding inline styles
            maxHeight: "168px !important"
          },
          "& .MuiDataGrid-virtualScroller":{
            maxHeight: "unset !important"
          },

        }}
        
               rows={gridDataFiltered}
               getRowId={(row) => row.id}
               columns={selectColumn()}
               disableRowSelectionOnClick={true}
               checkboxSelection={true}
               onRowSelectionModelChange={(selRows) => {
                  handleRowSelectionChange(selRows);
               }}
               rowSelectionModel={selectedRows}
               pageSizeOptions={[20, 50, 100]}
               paginationModel={paginationModel}
               onPaginationModelChange={setPaginationModel}
               disableColumnMenu
               disableColumnFilter
               disableColumnSelector
            />
            </div>
         </Grid>
      </Grid>
   );
}

export default DefineQuotaBreakdown;